import React from 'react';

import { IQuestion } from 'modules/lesson-detail';

import Options from './options';
import TopSection from './top-section';

interface IProps {
  data?: IQuestion;
}

const Test: React.FC<IProps> = ({ data }) => (
  <div className="shadow-xs space-y-3 rounded-xl bg-white px-4 py-3">
    <div className="px-1">
      <TopSection questionId={data?.question_id} title={data?.name} />
    </div>
    <Options testId={data?.id} options={data?.options} />
  </div>
);

export default Test;
